import * as z from 'zod';
import { zMobileNumber } from '../error-messages';

export const updateMobileNumberFormSchema = z.object({
  mobileNumber: zMobileNumber,
});

export type UpdateMobileNumberForm = z.TypeOf<
  typeof updateMobileNumberFormSchema
>;
